import React from 'react';
import { AuthProvider } from './src/context';
import { trackPageTime } from '../shared/utils/Analytics';
import { UserProgressContextProvider } from './src/context/UserProgressContext';
import './src/styles/global.css';

let previousSearch = '';

export const onRouteUpdate = (location, prevLocation) => {
  if (typeof window !== 'undefined') {
    // Fire PageViewPing for the previous page
    if (prevLocation || previousSearch !== window.location.search) {
      trackPageTime();
    }
    // Update the stored query string
    previousSearch = window.location.search;
  }
};

export const wrapRootElement = ({ element }) => {
  return (
    <AuthProvider>
      <UserProgressContextProvider>{element}</UserProgressContextProvider>
    </AuthProvider>
  );
};
